<template>

    <v-sheet class="mb-5" style="background-color:#fff;" v-if="isrc != ''">
      
        <v-app-bar
            app
            dense
            fixed
            elevate-on-scroll
            style="border-bottom:1px solid #ddd; padding:0px; "
            elevation="0"
        >
            <v-btn :to="{name:'isrcs'}" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>{{page_title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <!--template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn small text elevation="0" color="primary">
                        <v-icon>save</v-icon>&nbsp; Salvar Rascunho
                    </v-btn>&nbsp;
                </template-->
            </v-toolbar-items>
        </v-app-bar>
        <v-container >
            <v-layout wrap>
                <v-flex xs12 md5>
                    <v-card class="mx-auto" min-height="150" max-width="900" outlined>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="overline mb-4">Produto</div>
                                <v-list-item-title class="headline mb-1">{{ isrc.product.name }}</v-list-item-title>
                                <v-list-item-subtitle
                                    class="text--primary"
                                    v-text="isrc.product.artist.name"
                                ></v-list-item-subtitle>
                                <v-list-item-subtitle v-text="isrc.product.status"></v-list-item-subtitle>
                                <v-list-item-subtitle >Lançamento: {{isrc.product.release_date}}</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar tile size="80" color="grey">
                                <v-img :src="computed_thumbnail" />
                            </v-list-item-avatar>
                        </v-list-item>
                    </v-card>
                </v-flex>

                <v-flex xs12 offset-md-2 md5>
                    <v-card class="mx-auto" min-height="150" max-width="900" outlined>
                        <v-list-item three-line>
                            <v-list-item-content>
                                <div class="overline mb-4">Faixa</div>
                                <v-list-item-title class="headline mb-1">{{ isrc.track.name }}</v-list-item-title>
                                <v-list-item-subtitle
                                    class="text--primary"
                                    v-if="isrc_info != null"
                                >Gravação: {{isrc_info.type}} </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="text--primary"
                                    v-if="isrc_info != null"
                                >ISRC: {{isrc.isrc}} </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-flex>

                <v-flex xs12  mt-5 v-if="isrc_info">
                    <div class="headline mb-2">ISRC</div>
                    <v-card class="mx-auto" outlined>
                        
                        <template >                            
                            <v-data-table
                            
                                :items-per-page="300"
                                v-if="isrc_info.participantes != undefined"
                                :items="isrc_info.participantes"
                                :headers="[ {text:'Nome completo',value:'fullname'},
                                                                            {text:'Nome artistíco/pseudônimo',value:'alias'},
                                                                            {text:'CPF/CNPJ',value:'br_cpf_cnpj'},
                                                                            {text:'Função',value:'tipo.cat'},
                                                                            {text:'Instrumentos',value:'instrumentos'},
                                                                            {text:'Ações',value:'acoes'},
                                                                            ]"
                                hide-default-footer
                            >
                                <template
                                    v-slot:item.instrumentos="{ item }"
                                >{{ item.instrumentos ? item.instrumentos.join(', '):''}}</template>

                                <!--template v-slot:item.acoes="{item}"></template-->
                            </v-data-table>
                        </template>
                    </v-card>
                </v-flex>

                 <v-flex xs12  mt-5 v-if="isrc.track">
                    <div class="headline mb-2"> Obra </div>
                    <v-card class="mx-auto px-5 py-4"   outlined>
                        <table v-for="work in works" :key="work.id" width="100%">
                            <tr class="pt-3 ">
                                <td>Obra: {{work.name}}</td>
                                <td>ISWC: {{work.iswc==null?"NÃO":work.iswc}}</td>
                                <td>Versão: {{ (work.version==null?"NÃO":"SIM") }} </td>
                                <td> <span v-if="work.version!=null" >Nome da versão: {{ work.version_name }} </span> </td>
                            </tr>
                            <tr>
                                <td colspan="4" class=" py-3"><v-divider /></td>
                            </tr>
                            <tr>
                                <th align="left" >Nome</th>
                                <th align="left" >Pseudônimo</th>
                                <th align="left" >CPF/CNPJ</th>
                                <th align="left" >Participação</th>
                            </tr>
                            <tr v-for="composer in work.own_rights_info.composers" :key="composer.name">
                                <td>{{composer.name}}</td>
                                <td>{{composer.alias}}</td>
                                <td>{{get_cpfcnpj(composer)}}</td>
                                <td>{{composer.pivot.share}}</td>
                            </tr>

                        </table>
                       
                    </v-card>
                 </v-flex>
            </v-layout>
        </v-container>
    </v-sheet>
</template>
<script>
import IsrcsService from "../../../app/rest/isrcs";
var isrcsService = null;

export default {
    data: () => ({
        page_title: "",
        isrc: "",
        isrc_info: null,
        works:null,
    }),
    beforeCreate: function() {
        this.$store.dispatch("loading");
        isrcsService = IsrcsService.build();
        isrcsService
            .get_one(this.$route.params.id)
            .then(e => {
                if (e.status == "ok") {
                    this.isrc = e.items.isrc;
                    this.page_title = `${this.isrc.track.name} - ${this.isrc.isrc}`;
                    if (this.isrc.track) {
                        this.isrc_info = JSON.parse(this.isrc.track.isrc_info);
                        if(this.isrc.track.works.length > 0){
                            
                            this.works = this.isrc.track.works.map( e =>{
                                e.own_rights_info = JSON.parse(e.own_rights_info);
                                return e;
                            });

                            
                        }
                    }
                    
                }

                console.log(this.isrc);
            })
            .catch(e => {})
            .finally(() => {
                this.$store.dispatch("loading", false);
            });
    },
    computed: {
        computed_thumbnail() {
            if (this.isrc.product.thumbnail) {
                return (
                    process.env.VUE_APP_BASE_URL + this.isrc.product.thumbnail
                );
            } else if (this.isrc.product.thumbnail != null) {
                return this.isrc.product.thumbnail;
            } else {
                return "";
            }
        }
    },
    methods: {
        get_cpfcnpj(composer){
            if(composer.cpf){
                return composer.cpf
            }
            return composer.pivot.br_cpf_cnpj;
        }
    }
};
</script>

        
   